import OTPVerification from './OTPVerification';

export default OTPVerification;
